// Keep browser navigation behind a mockable boundary for jsdom-based tests.
export const navigateTo = (url: string) => window.location.assign(url);

export const reloadPage = () => window.location.reload();
